var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransactions = function SvgTransactions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.429 1.677a8.334 8.334 0 0 1-.43 16.656l-.428-.01A8.334 8.334 0 0 1 10 1.667zm-4.04 9.087 4.242 3.413v-1.885h3.396v-1.528zm4.24-3.056h-4.24v1.528h7.638L10.63 5.814z",
    clipRule: "evenodd"
  })));
};
export default SvgTransactions;